import { render, staticRenderFns } from "./roleInfoForm.vue?vue&type=template&id=fa1d33c0&"
import script from "./roleInfoForm.vue?vue&type=script&lang=js&"
export * from "./roleInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./roleInfoForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports